module.exports = __webpack_public_path__ + "static/ohq-product-06db4c5c250f280cfb12af538a65ddf9.svg";